"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paymentSummaryRow = exports.paymentSummary = exports.iconButton = exports.icon = void 0;

var _react = require("@emotion/react");

var _legacy = require("../../../components/legacy");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  margin: 12px 0;\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  border: solid 1px ", ";\n  margin: 36px 0 0;\n\n  & > div {\n    margin: -12px 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  padding: 0 4px;\n  cursor: pointer;\n  vertical-align: middle;\n  color: ", ";\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 16px;\n  width: auto;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var icon = (0, _react.css)(_templateObject());
exports.icon = icon;

var iconButton = function iconButton(_ref) {
  var colors = _ref.colors;
  return (0, _react.css)(_templateObject2(), colors.neutral[600]);
};

exports.iconButton = iconButton;

var paymentSummary = function paymentSummary(_ref2) {
  var colors = _ref2.colors;
  return (0, _react.css)(_templateObject3(), colors.neutral[100]);
};

exports.paymentSummary = paymentSummary;

var paymentSummaryRow = function paymentSummaryRow(isLoading) {
  return function (_ref3) {
    var colors = _ref3.colors;
    return (0, _react.css)(_templateObject4(), isLoading && "  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: 2px;\n    margin: 3px 0;\n    background: linear-gradient(\n      90deg,\n      ".concat(colors.neutral[200], " 0%,\n      ").concat((0, _legacy.hexRgb)(colors.neutral[200], 0), " 128.58%\n    );\n    z-index: 1;\n  }"));
  };
};

exports.paymentSummaryRow = paymentSummaryRow;